import { z } from 'zod';

export const cancelRun = (runUuid: string) => {
  return {
    endpoint: `/hooks/runs/${runUuid}/cancel`,
    method: 'POST',
    responseSchema: z.unknown(),
  } as const;
};
